if (!customElements.get('dyo-open-link')) {
  class DYOOpenLink extends HTMLElement {
    constructor() {
      super();
      this.dialogId = null;
      this.handleChildAnchorClick = this.handleChildAnchorClick.bind(this);
    }

    connectedCallback() {
      this.dialogId = this.getAttribute('data-dialog-id');

      if (!this.dialogId) {
        console.warn(
          'DYOOpenLink: No data-dialog-id attribute found. This component is designed to work with a dialog/modal. Please provide the ID of the dialog/modal to open in the data-dialog-id attribute.',
        );

        return null;
      }

      this.addEventListener('click', this.handleChildAnchorClick, true);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleChildAnchorClick, true);
    }

    handleLocalStorage() {
      const modalKey = `modal-open-${this.dialogId}`;
      localStorage.setItem(modalKey, 'true');
    }

    /**
     * Listen for clicks on child <a> tags and handle them.
     * @param {MouseEvent} event
     */
    handleChildAnchorClick(event) {
      const anchor = event.target.closest('a');
      if (anchor && this.contains(anchor)) {
        this.handleLocalStorage();
        this.dispatchEvent(
          new CustomEvent('dyo-anchor-click', {
            detail: { href: anchor.href },
            bubbles: true,
            composed: true,
          }),
        );
      }
    }
  }

  customElements.define('dyo-open-link', DYOOpenLink);
}
